import angular from "angular";
import panel from "../services";
import { EmojiButton } from '@joeattardi/emoji-button';

function matchesMessage (panel) {
  return {
    restrict: 'E',
    scope: {
      item : '='
    },
    link: (scope, element) => {
      panel.registerEvent('current.match.set', (data) => {
        if (data.detail) {
          scope.person = data.detail;
        }
      });

      scope.msg = {
        recipient: null,
        message: ''
      };

      scope.panel = panel;

      scope.sendMessage = () => {
        scope.msg.recipient = scope.person.screen_name;
        if (scope.msg.message && scope.msg.message.trim() !== '') {
          panel.post('/v1/inbox/chat',scope.msg, (response) => {
            scope.msg.message = '';
            if (panel.okay(response)) {
                $('[data-close]').trigger('click');
                panel.dashboard_message('Message sent successfully!');
            }
          });
        }
      };

      $(document).ready(() => {
        const button = document.querySelector('#emoji-button-dir');
        const pickerBtn = new EmojiButton();

        pickerBtn.on('emoji', emoji => {
          scope.msg.message += emoji.emoji;
          scope.$apply();
        });

        button.addEventListener('click', () => {
          pickerBtn.pickerVisible ? pickerBtn.hidePicker() : pickerBtn.showPicker(button);
          $('.emoji-picker__wrapper').css({'z-index': 1000000, 'top' : '300px'});
        });
      });
    },

    template: require('./templates/matches-message.html')
  }
};

export default angular.module('directives.matchesMessage', [panel]).directive('matchesMessage', matchesMessage).name;



// WEBPACK FOOTER //
// ./src/app/directives/matchesMessage.js